import { ChangeEvent } from 'react';

export interface SwitchProps {
  text?: string;
  id?: string;
  name?: string;
  value?: string | number | string[];
  checked?: boolean;
  labelAttrs?: any;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  active?: {
    color?: string;
    borderColor?: string;
  };
}

export const Switch = (props: SwitchProps) => {
  const text = props.text;
  return (
    <div className="beauty-checkbox-component">
      <input
        id={props.id}
        type="checkbox"
        className="switch"
        value={props.value ?? ''}
        checked={props.checked === true}
        onChange={props.onChange}
        name={props.name}
        {...{ disabled: props.disabled }}
      />
      {!text ? '' : <label htmlFor={props.id} {...props.labelAttrs ?? {}}>{props.text ?? ''}</label>}
    </div>
  );
}
